import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  Home, 
  Truck, 
  Plus, 
  Users, 
  Building2, 
  BarChart3,
  Anchor,
  User,
  LogOut,
  Settings,
  Ship
} from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Sidebar = () => {
  const navigation = [
    { name: 'Tableau de bord', href: '/', icon: Home },
    { name: 'Saisies', href: '/saisies', icon: Truck },
    { name: 'Nouvelle saisie', href: '/nouvelle-saisie', icon: Plus },
    { name: 'Clients', href: '/clients', icon: Users },
    { name: 'Drydocs', href: '/drydocs', icon: Ship },
    { name: 'Rapports', href: '/rapports', icon: BarChart3 },
    { name: 'Utilisateurs', href: '/utilisateurs', icon: User },
    { name: 'Paramètres', href: '/parametres', icon: Settings },
  ];

  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="w-64 bg-white shadow-lg border-r border-port-gray-200 flex flex-col h-screen">
      <div className="flex items-center justify-center h-16 bg-atl-blue-600">
        <div className="flex items-center space-x-2">
          <span className="text-white font-bold text-xl">ATL Méditerranée</span>
        </div>
      </div>
      
      <nav className="mt-8 flex-1">
        <div className="px-4">
          <div className="text-xs font-semibold text-port-gray-500 uppercase tracking-wider mb-4">
            Navigation
          </div>
        </div>
        
        <div className="space-y-1">
          {navigation.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) =>
                  `flex items-center px-4 py-3 text-sm font-medium transition-colors duration-200 ${
                    isActive
                      ? 'bg-atl-blue-50 text-atl-blue-700 border-r-2 border-atl-blue-600'
                      : 'text-port-gray-600 hover:bg-port-gray-50 hover:text-port-gray-900'
                  }`
                }
              >
                <Icon className="mr-3 h-5 w-5" />
                {item.name}
              </NavLink>
            );
          })}
        </div>
      </nav>
      
      {/* Profil utilisateur et déconnexion */}
      <div className="p-4 border-t border-port-gray-200 flex items-center justify-between">
        <NavLink to="/profil" className="flex items-center space-x-2 group">
          <div className="h-8 w-8 rounded-full bg-atl-blue-100 flex items-center justify-center">
            <User className="h-5 w-5 text-atl-blue-600" />
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-medium text-port-gray-900 group-hover:text-atl-blue-700 transition-colors">{currentUser?.nom || 'Profil'}</span>
            <span className="text-xs text-port-gray-500">{currentUser?.role}</span>
          </div>
        </NavLink>
        <button onClick={handleLogout} className="ml-4 text-port-gray-400 hover:text-red-600 transition-colors" title="Déconnexion">
          <LogOut className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default Sidebar; 